import { render, staticRenderFns } from "./Info_ListBullet.vue?vue&type=template&id=f5ab55c0&scoped=true&"
import script from "./Info_ListBullet.vue?vue&type=script&lang=js&"
export * from "./Info_ListBullet.vue?vue&type=script&lang=js&"
import style0 from "./Info_ListBullet.vue?vue&type=style&index=0&id=f5ab55c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5ab55c0",
  null
  
)

export default component.exports